var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNotAvailableImg = function SvgNotAvailableImg(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89 9.88889V42.4728L74.1667 27.59L54.3889 47.4172L34.6111 27.6394L14.8333 47.4172L0 32.5344V9.88889C0 4.45 4.45 0 9.88889 0H79.1111C84.55 0 89 4.45 89 9.88889ZM74.1667 41.6322L89 56.515V79.1111C89 84.55 84.55 89 79.1111 89H9.88889C4.45 89 0 84.55 0 79.1111V46.5767L14.8333 61.3606L34.6111 41.5828L54.3889 61.3606L74.1667 41.6322Z",
    fill: "white",
    fillOpacity: 0.56
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNotAvailableImg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/notAvailableImg.9820e584d2d5ce03d8c621ff8488a461.svg";